module.exports = __webpack_public_path__ + "img/77412.2f647969.svg";